export class GridContext {
    readonly showImageNoticeText: boolean;
    readonly showTurnoverRatioText: boolean;

    constructor(gridPrefix: string) {
        // Atm only for Glitre (001) and Tensio TS (059 in prod/082 in demo) 
        // Føre AS has the gridPrefix 082 in prod, but they dont have AO app. If they purchase AO app, we have to review this solution
        this.showImageNoticeText = gridPrefix === "001" || gridPrefix === "059" || gridPrefix === "082";
        this.showTurnoverRatioText = gridPrefix === "001";
    }
    // This context can be expanded where company specific customization is needed
}